import { API_ENDPOINT, AUTHORIZATION_CODE } from "../constants";

export const getEventDownloadLink = (api, event_id, user_profile_id) => {
    let formData = new FormData();
      formData.append("api_key", api);
      formData.append("event_id", event_id);
      formData.append("user_profile_id", user_profile_id);

    return fetch(`${API_ENDPOINT}/get-event-download-link`, {
        method: 'post',
        body: formData
    })
        .then((data) => data.json())
        .then((res) => res)
        .catch((error) => {
            console.warn(error)
            return []
        });
};

export const requestEventDownloadLink = (api, event_id, user_profile_id, name, email) => {
    let formData = new FormData();
      formData.append("api_key", api);
      formData.append("event_id", event_id);
      formData.append("user_profile_id", user_profile_id);
      formData.append("name", name);
      formData.append("email", email);

    return fetch(`${API_ENDPOINT}/request-download`, {
        method: 'post',
        body: formData
    })
        .then((data) => data.json())
        .then((res) => res)
        .catch((error) => {
            console.warn(error)
            return []
        });
};

